import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import PageMeta from '../utils/PageMeta';
import useErrorRedirectEffect from '../utils/error/useErrorRedirectEffect';

const CUSTOM_REPORT_QUERY = gql(/** @complexity 1 */ `
  query reportUrl($reportId: String!) {
    url: reportUrl(reportId: $reportId)
  }
`);

export default () => {
  const params = useParams();
  const { data, error } = useQuery(CUSTOM_REPORT_QUERY, {
    fetchPolicy: 'network-only',
    skip: !params.reportId,
    variables: { reportId: params.reportId ?? '' },
  });

  useErrorRedirectEffect({ error, noun: 'report' });

  return (
    <>
      <PageMeta title="Custom Reports - Slab" />
      {data?.url && (
        <iframe
          style={{ border: 0, height: '100%', width: '100%' }}
          src={data.url}
          title="Custom Report"
        />
      )}
    </>
  );
};
